import styles from './Analytics.module.scss';
import { useTranslation } from 'react-i18next';
import { NavTabs } from '@cas/components/tabs/nav-tabs/NavTabs';
import Page from '@customer/templates/page/Page';
import { Outlet } from 'react-router-dom';
import { QueryTag } from '@customer/store/api';
import RefreshButton from '@customer/components/inputs/refresh-button/RefreshButton';
import { NavTabModel } from '@cas/components/tabs/nav-tab/NavTab';
import { TagDescription } from '@reduxjs/toolkit/query';

const tagsToClearOnRefresh: TagDescription<QueryTag>[] = [
  { type: QueryTag.Asset, id: 'LIST' },
  QueryTag.ConfigGroup,
  QueryTag.Health,
  QueryTag.ScenariosStat,
  QueryTag.ScenariosTimeSeries,
  { type: QueryTag.Metadata, id: 'VEHICLEGROUPS' },
];

export function Analytics() {
  const { t } = useTranslation();

  const tabs: NavTabModel[] = [
    { title: t('Summary'), to: '/health/summary' },
    { title: t('SelfTest'), to: '/health/self-test' },
    { title: t('Configuration'), to: '/health/configuration' },
    { title: t('Reporting'), to: '/health/reporting' },
  ];

  return (
    <Page
      header={
        <div className={styles.header}>
          <span>{t('CasHealth')}</span>
          <RefreshButton tagsToClear={tagsToClearOnRefresh} />
        </div>
      }
      nav={<NavTabs tabs={tabs} hasBorder />}
    >
      <Outlet />
    </Page>
  );
}

export default Analytics;
